module.exports = __webpack_public_path__ + "img/16k016-07.955873d1.jpg";